import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as suggestionApi from "../../api/suggestionApi/suggestionApi";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {EQSuggestion, initializeSuggestion} from "../../models/serverModels/report/EQSuggestion";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import SuggestionForm from "./SuggestionForm";

const CreateSuggestion = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQSuggestion>,
    Params.Create<EQSuggestion>
  >({
    api: suggestionApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Suggestion`);
        queryClient.invalidateQueries("SuggestionList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<EQSuggestion>({
    defaultValues: initializeSuggestion(),
  });
  const onSubmit: SubmitHandler<EQSuggestion> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeSuggestion(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="질의 작성" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <SuggestionForm />
          <ConfirmButtonGroup link={`/Suggestion`} cancelText="취소" confirmText="등록" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateSuggestion;
